import type { Variants } from 'framer-motion'

// Shared page-enter motion, used by every page/section so the fade+spring
// entrance animation looks consistent and plays on every visit.
export const pageContainerVariants: Variants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { duration: 0.4, staggerChildren: 0.08, delayChildren: 0.04 },
  },
}

export const pageItemVariants: Variants = {
  hidden: { opacity: 0, y: 14, scale: 0.98 },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: { type: 'spring', stiffness: 320, damping: 26, mass: 0.7 },
  },
}
